module.exports = __webpack_public_path__ + "static/media/ocean_waves.2ad75e08.mp3";